import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { switchMap, map, take } from 'rxjs/operators';

import {
  EntityConnectionTypeDetailsFragment, GetEntityConnectionTypesGQL, GetEntityPublicGQL,
  GetEntityPublicQuery, GetTagsByIdsForQueryGQL, GetTagsByIdsForQueryQuery, SearchActivityEvents
} from 'generated/graphql';

import { selectCampaignId } from 'app/_state/router/router-selectors';
import {
  MassAddOrUpdateEntityConnectionOperationData
} from 'app/quick-apply/types/mass-operation-types';
import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';

import { MassOperationActivityEventPayload } from '../types';
import { isNilOrEmpty } from 'helpers';

@Component({
  selector: 'app-mass-update-connection-event',
  templateUrl: './mass-update-connection-event.component.html'
})
export class ASMassUpdateConnectionComponent extends
  WithDisposableSubject() implements OnInit {
  @Input() item: SearchActivityEvents.Node;

  get payload():
    MassOperationActivityEventPayload<MassAddOrUpdateEntityConnectionOperationData> {
    return this.item?.payload;
  }

  entityConnectionType: EntityConnectionTypeDetailsFragment;
  entity: GetEntityPublicQuery['getEntityPublic'];
  removedTags: GetTagsByIdsForQueryQuery['getTagsByIds'];
  appliedTags: GetTagsByIdsForQueryQuery['getTagsByIds'];

  /**
   *
   */
  constructor(
    private _getTagsService: GetTagsByIdsForQueryGQL,
    private _getEntityPublic: GetEntityPublicGQL,
    private _getEntityConnectionTypes: GetEntityConnectionTypesGQL,
    private _store: Store,
    private _cd: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
    const opData = this.payload.operationData;
    this._setAppliedTags();
    this._setRemovedTags();

    this._store.select(
      selectCampaignId
    ).pipe(
      take(1),
      switchMap((campaignId: string) => this._getEntityPublic.fetch(
        {
          campaignId,
          entityId: opData.toEntityId
        }
      ).pipe(
        map(({ data }) => data.getEntityPublic),
        switchMap((entity) => this._getEntityConnectionTypes.fetch().pipe(
          map(({ data }) => {
            const entityConnectionType = data
              .getEntityConnectionTypes.find(d => d.id === opData.entityConnectionTypeId);
            return {
              entity, entityConnectionType
            };
          })
        ))
      )
      ),
    )
      .subscribe(
        (vm) => {
          this.entity = vm.entity;
          this.entityConnectionType = vm.entityConnectionType;
          this._cd.markForCheck();
        }
      );
  }

  private _setAppliedTags() {
    const tagIds = this.payload.operationData.applyTagsData?.map(t => t?.tagId);
    if (isNilOrEmpty(tagIds)) {
      return;
    }
    this._getTags(tagIds).subscribe(
      (tags) => {
        this.appliedTags = tags;
        this._cd.markForCheck();
      }
    );
  }

  private _setRemovedTags() {
    const tagIds = this.payload.operationData.unapplyTagIds;
    if (isNilOrEmpty(tagIds)) {
      return;
    }
    this._getTags(tagIds).subscribe(
      (tags) => {
        this.removedTags = tags;
        this._cd.markForCheck();
      }
    );
  }

  private _getTags(tagIds: string[]) {
    return this._getTagsService.fetch({
      tagIds
    }).pipe(
      map(({ data }) => data.getTagsByIds)
    );
  }

}

